import styled from 'styled-components'
import { AgreementDescription, AgreementTitle } from '@/components/agreement'
import { Button } from '@/components/anchor'
import Content from '@/components/content'
import Taskbar from '@/components/taskbar'
import Tool from '@/components/tools'

const AgreementWrapper = styled(Content)`
  min-height: 90vh;
`

const Agreement = ({ agreementId, onChange, onClose }) => {
  const renderConnectedAgreement = () => {
    if (agreementId === 'privacy_policy') {
      return <Button onClick={() => onChange('terms_conditions')}>Terms</Button>
    } else if (agreementId === 'terms_conditions') {
      return <Button onClick={() => onChange('privacy_policy')}>Privacy</Button>
    }

    return null
  }
  return (
    <>
      <Taskbar left={renderConnectedAgreement()} right={<Tool type="close" onClick={onClose} />}>
        <AgreementTitle agreementId={agreementId} />
      </Taskbar>
      <AgreementWrapper bottom={30}>
        <AgreementDescription agreementId={agreementId} />
      </AgreementWrapper>
    </>
  )
}

export default Agreement
